<template>
  <van-dialog v-model:show="showNotify" confirm-button-text="Close" confirm-button-color="#007AFF"
    class="metfone-dialog" @confirm="handleCloseApp">
    <template #title>
      <div class="metfone-dialog-title"> {{ $t("sorry") }}</div>
    </template>
    <template #default>
      <div class="metfone-dialog-description"> {{ $t("not_is_metfone_1") }} {{ phoneNumber }} {{ $t("not_is_metfone_2")
      }}
      </div>
    </template>
  </van-dialog>
</template>
<script>

import { Dialog } from 'vant';

export default {
  name: "MetfoneNotify",
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    phoneNumber: {
      type: String,
      required: true,
      default: "0979097097"
    }
  },
  data() {
    return {
      showNotify: false
    }
  },
  created() {

  },
  watch: {
    isShow() {
      this.showNotify = this.isShow;
    }
  },
  mounted() {
    this.showNotify = this.isShow;
  },
  methods: {
    handleCloseApp() {
      this.$emit("update:isShow", false)
    }
  }
}
</script>

<style>
.metfone-dialog-title {
  color: #000;
  text-align: center;
  font-family: SF Pro Text;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
}

.metfone-dialog-description {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  color: #000;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.078px;
  padding-right: 16px;
  padding-left: 16px;
}
</style>
